<template>
    <div>
        <div class="pc">
            <toptab :topback="true"></toptab>
            <div class="microvideo">
                <div class="microvideoboxleft">
                    <asidebar></asidebar>
                </div>
                <div class="microvideoboxright" v-if="status">
                    <el-scrollbar>
                        <div class="swiperbox">
                            <div class="swiper">
                                <swiper :options="swiperOption" ref="mySwiper">
                                    <swiper-slide :class="swiperIndex==-1?'swiperOn':''"><span :data-index="-1">收藏</span></swiper-slide>
                                    <swiper-slide :class="swiperIndex==-0?'swiperOn':''"><span :data-index="0">全部</span></swiper-slide>
                                    <swiper-slide :class="swiperIndex==item.id?'swiperOn':''" v-for="(item,index) in swiperdata" :key="index"><span :data-index="item.id">{{item.title}}</span></swiper-slide>
                                </swiper>
                                <div class="swiper-prev">
                                    <svg style="transform: rotate(180deg);" t="1704181764265" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4568" width="64" height="64"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" p-id="4569" fill="#ffffff"></path></svg>
                                </div>
                                <div class="swiper-next">
                                    <svg t="1704181764265" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4568" width="64" height="64"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" p-id="4569" fill="#ffffff"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <ul>
                                <li v-for="(item,index) in list1" :key="index">
									<el-image  style="position: unset;" :src="item.show_image" alt="">
										<div slot="placeholder" class="image-slot">
											<img :src="imageLoading"/>
									    </div>
									</el-image>
                                    <div class="star" v-if="item.collect" @click="videoCollect(item.id,index)"><i class="el-icon-star-on"></i></div>
                                    <div class="star" v-else @click="videoCollect(item.id,index)"><i class="el-icon-star-off" ></i></div>
                                    <div class="create" @click="selectVideo(item.id)"><div><p>制作同款</p></div></div>
                                </li>
                            </ul>
							<el-button type="primary" @click="jumpCustomized()" style="text-align: center;" v-if="form.cid == 10000 && list1.length == 0">定制新形象</el-button>
                        </div>
                        <p class="tip">到底了</p>
                    </el-scrollbar>
                </div>
                <div class="microvideoboxright" v-else>
                    <microvideoD :tid="tid"></microvideoD>
                </div>
            </div>
        </div>
        <div class="mobile">
            <microvideom></microvideom>
        </div>
    </div>
</template>

<script>
import toptab from "@/components/toptab"
import asidebar from "@/components/asidebar"
import microvideom from "@/components/microvideom"
import microvideoD from "@/components/microvideoD"
import {videoGetList,videoCollect} from "@/api/video"
export default {
    components: {
        toptab,
        asidebar,
        microvideom,
        microvideoD,
    },
    data(){
        return{
			imageLoading:this.$store.website.image_loading,
            status:true,
            form:{
                cid:0,
                collect:0
            },
            tabindex:0,
            swiperIndex:0,
            swiperOption:{
                // slidesPerView:15,
                spaceBetween : 8,
                slidesPerView: "auto",
                navigation:{
                    prevEl:'.swiper-prev',
                    nextEl:'.swiper-next',
                },
                on: {
                    click: (e) =>  {
                        this.swiperClick(e)
                    }
                }
            },
            swiperdata:[

            ],
			aid:0,
            list1:[],
            tid:1,
        }
    },
    mounted(){
		if (this.$route.query.aid != undefined && this.$route.query.aid != "" && this.$route.query.aid != "0") {
			this.aid = this.$route.query.aid;
		}
        this.videoGetList()
    },
    methods:{
        closelogin(){
            this.loginbox = false
        },
		jumpCustomized() {
			this.$router.push({ path: '/customized'});
		},
        selectVideo(id){
            // this.tid = id
            // this.status=false
			if(this.aid > 0 ) {
				this.$router.push({ path: '/digital?tid=' + id + '&aid=' + this.aid});
			}else {
				this.$router.push({ path: '/digital?tid=' + id });
			}
			
        },
        videoGetList(){
            videoGetList(this.form).then(res=>{
                this.swiperdata = res.data.category
                this.list1 = res.data.template
            })
        },
        swiperClick(e){
            if(e.target.getAttribute('data-index')){
                if(e.target.getAttribute('data-index')==-1){
                    this.form.cid = 0
                    this.form.collect = 1
                }else{
                    this.form.cid = e.target.getAttribute('data-index')
                    this.form.collect = 0
                }
                this.swiperIndex = e.target.getAttribute('data-index')
                this.videoGetList()
            }
        },
        videoCollect(id,index){
            videoCollect({tid:id}).then(res=>{
                if(res.code==0){
                    if(this.list1[index].collect){
                        this.list1[index].collect = 0
                    }else{
                        this.list1[index].collect = 1
                    }
                }
                this.$message(res.message);
            })
        },
    }
}
</script>

<style lang="less">
    @media (min-width:1600px) {
        .microvideo{
            .list{
                li{
                    flex: 0 0 23%;
                }
            }
        }
    }
    @media (max-width:1600px) {
        .microvideo{
            .list{
                li{
                    flex: 0 0 32%;
                }
            }
        }
    }
    .microvideo{
        display: flex;
        .microvideoboxright{
            padding: 30px 20px 0;
            // flex: 1 0 10%;
            width:calc(100vw - 340px);
            .el-scrollbar{
                height: calc(100vh - 90px);
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }
            .microvideoheader{
                .title{
                    font-size: 36px;
                    font-weight: 700;
                    color: #191919;
                    text-align: center;
                }
                .tab{
                    width: 600px;
                    padding: 20px 0;
                    border-bottom: 1px solid #e6e9ed;
                    margin: auto;
                    ul{
                        display: flex;
                        gap: 20px;
                        justify-content: center;
                        li{
                            font-size: 16px;
                            font-weight: 700;
                            height: 46px;
                            width: 160px;
                            background: #fff;
                            border: 1px solid #dfeaff;
                            border-radius: 23px;
                            cursor: pointer;
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .on{
                            color: #fff;
                            background: linear-gradient(90deg,#33adff 0%,#1a7af8 99%);
                            border: 0;
                        }
                        .on::after{
                            content: "";
                            position: absolute;
                            bottom: -30px;
                            left: 50%;
                            width: 18px;
                            height: 18px;
                            border-top: 1px solid #e6e9ed;
                            border-left: 1px solid #e6e9ed;
                            transform: translate(-50%) rotate(45deg);
                            z-index: 100;
                        }
                    }
                }
            }
            .swiperbox{
                position: sticky;
                top: 0;
                background-color: #fff;
                z-index: 100;
            }
            .swiper{
                width: 100%;
                position: relative;
                margin-top: 40px;
                height: 34px;
                span{
                    display: block;
                    width: 100%;
                    height: 100%;
                    line-height: 28px;
                }
            }
            .swiper:hover .swiper-prev,.swiper:hover .swiper-next{
                opacity: 1;
            }
            .swiper-container{
                align-items: center;
                margin-left: 0;
                margin-right: 0;
                
            }
            .swiper-slide{
                // max-width: 100px;
                width: 80px;
                height: 30px;
                text-align: center;
                // padding: 5px 12px;
                border: 1px solid #f4f5f7;
                border-radius: 6px;
                background: #fff;
                flex-shrink: 0;
                cursor: pointer;
                position: relative;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .swiperOn{
                border-color: #2d8af5;
                background: #fff;
                color: #2d8af5;
            }
            .swiper-next{
                position: absolute;
                z-index: 100;
                width: 20px;
                height: 100%;
                border-radius: 8px 0 0 8px;
                cursor: pointer;
                background: rgba(0,0,0,.4);
                color: #fff;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-transform: translateZ(0);
                opacity: 0;
                svg{
                    width: 14px !important;
                    height: 14px !important;
                }
            }
            .swiper-prev{
                position: absolute;
                z-index: 100;
                width: 20px;
                height: 100%;
                border-radius: 0 8px 8px 0;
                cursor: pointer;
                background: rgba(0,0,0,.4);
                color: #fff;
                left: 0;
                top: 0%;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-transform: translateZ(0);
                opacity: 0;
                svg{
                    width: 14px !important;
                    height: 14px !important;
                }
            }
        }
        .list{
            padding-top: 20px;
            ul{
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                li{
                    border-radius: 8px;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;
                }
                li:hover{
                    .star{
                        display: flex;
                    }
                    .create{
                        display: block;
                    }
                }
                img{
                    width: 100%;
                    display: block;
                }
                div{
                    position: absolute;
                }
                .star{
                    top: 10px;
                    right: 10px;
                    width: 28px;
                    height: 28px;
                    font-size: 16px;
                    border-radius: 4px;
                    background: rgba(0,0,0,.7);
                    color: #fff;
                    align-items: center;
                    justify-content: center;
                    display: none;
                }
                .create{
                    bottom: 30px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 120px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    border-radius: 18px;
                    background: rgba(0,0,0,.8);
                    color: #fff;
                    display: none;
                    div{
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    p{
                        position: relative;
                        z-index: 11;
                        width: 120px;
                        height: 36px;
                        line-height: 36px;
                        text-align: center;
                        border-radius: 18px;
                        background: rgba(0,0,0,.8);
                        color: #fff;
                    }
                    div::after{
                        content: "";
                        display: block;
                        width: 124px;
                        height: 40px;
                       // position: absolute;
                        top: -2px !important;
                        left: -2px !important;
                        inset: 0;
                        z-index: -10;
                        border-radius: 50px;
                        background-image: linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%)
                    }
                }
            }
        }
        .tip{
            color: #999;
            font-size: 12px;
            text-align: center;
            margin-top: 12px;
        }
    }
</style>